export default __webpack_public_path__ + "6200ccb4452d98b1c9c4c6b01f3d691d.svg";